import { useDragInfo, useBoardSize, useWidgetPositions } from '../hooks';
import Widget from './Widget';

const Widgets = ({ children }) => {
  const dragInfo = useDragInfo();
  const widgetPositions = useWidgetPositions();
  const { boardHeight } = useBoardSize();

  return widgetPositions.map(
    ({
      id,
      position: { top, left, width },
      collapsed,
      indexRow,
      firstRow,
      lastRow,
    }) => {
      const dragged = dragInfo?.id === id;
      const dragging = !!dragInfo;

      return (
        <Widget
          key={id}
          id={id}
          top={top}
          left={left}
          width={width}
          dragInfo={dragInfo}
          dragged={dragged}
          dragging={dragging}
        >
          {children({
            id,
            dragging,
            dragged,
            collapsed,
            indexRow,
            firstRow,
            lastRow,
            mounted: !!boardHeight,
          })}
        </Widget>
      );
    }
  );
};

export default Widgets;
